import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../../messages";
import WFlowEmpleadosServices from "./wFlowEmpleados.services";
import toastr from "toastr";

// export const getWorkFlow = (filters, id) => async (dispatch) => {
//   try {
//     dispatch({
//       type: actions.LOADING_WORKFLOW_EMP,
//       payload: true,
//     });
//     const resp = await WFlowEmpleadosServices.getWorkFlow(id);
//     dispatch({
//       type: actions.GET_WORKFLOW_EMP,
//       payload: {
//         workflow: [resp.data],
//       },
//     });
//   } catch (ex) {
//     let message = "";
//     if (axios.isAxiosError(ex)) {
//       if (ex.response?.status) {
//         switch (ex.response.status) {
//           case 400:
//             if (Array.isArray(ex.response.data)) {
//               ex.response.data.forEach((item) => {
//                 toastr.error(item);
//               });
//             } else {
//               toastr.error(ex.response.data);
//             }
//             break;
//           case 500:
//             message = messages.errorMessage + ex.response.statusText;
//             break;
//           default:
//             message = ex.response.data;
//             break;
//         }
//       } else {
//         message =
//           ex.message === "Network Error" ? messages.networkError : ex.message;
//       }
//     } else {
//       message =
//         ex.message === "Network Error" ? messages.networkError : ex.message;
//     }
//   } finally {
//     dispatch({
//       type: actions.LOADING_WORKFLOW_EMP,
//       payload: false,
//     });
//   }
// };

export const getEmployeesWorkFlow = params => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOW_EMP,
      payload: true,
    });
    const resp = await WFlowEmpleadosServices.getEmployeeWorkFlow(params);
    dispatch({
      type: actions.GET_WORKFLOWS_EMP,
      payload: {
        workflowEmployees: resp.data.data,
        workflowEmployeesLength: resp.data.count
      },
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.WORKFLOW_EMP_ERROR,
      payload: message
    });
  } finally {
    dispatch({
      type: actions.LOADING_WORKFLOW_EMP,
      payload: false,
    });
  }
};

export const saveWorkFlowEmp = (data, setWorkflowUsers) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOW_EMP,
      payload: true,
    });
    let response = await WFlowEmpleadosServices.saveWorkFlowEmp(data);
    /* dispatch({
      type: actions.GET_WORKFLOWS_EMP,
      payload: {
        workflowEmployees: [resp.data],
      },
    }); */
    if(response.data.correos_no_enviados && response.data.correos_no_enviados.length>0){
      response.data.correos_no_enviados.forEach(msg=>{
        toastr.error(msg,"Correo no Enviado", {closeButton:true, timeOut:0, extendedTimeOut:0})
      })
    }else{
      toastr.success(messages.successMessage);
    }
    dispatch({
      type: actions.MESSAGE_SAVE_WORKFLOW_EMP,
      payload: 'WorkFlows asignados con éxito'
    });
    setWorkflowUsers([]);
    //props.history.push(`/Monitor/${workflowType ? 'OnBoarding' : 'OffBoarding'}/${workflowType}`);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 404:
            toastr.error(ex.response.data.mensaje);
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message = ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.WORKFLOW_EMP_ERROR,
      payload: message
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOW_EMP,
      payload: false,
    });
  }
};

export const resetSuccessMessage = () => async dispatch => dispatch({
  type: actions.MESSAGE_SAVE_WORKFLOW_EMP,
  payload: ''
});

/* export const editWorkFlowEmp = (id, data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWS_EMP,
      payload: true,
    });

    const resp = await WFlowEmpleadosServices.editWorkFlowEmp(id, data);

    dispatch({
      type: actions.GET_WORKFLOWS_EMP,
      payload: {
        workflows: resp.data.data,
      },
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_WORKFLOWS_EMP,
      payload: false,
    });
  }
}; */

export const deleteWorkFlowEmp = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWS_EMP,
      payload: true,
    });
    await WFlowEmpleadosServices.deleteWorkFlowEmp(id);
    dispatch({
      type: actions.GET_WORKFLOWS_EMP,
      payload: {
        workflows: [],
      },
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.WORKFLOW_EMP_ERROR,
      payload: message
    })
  } finally {
    dispatch({
      type: actions.LOADING_WORKFLOWS_EMP,
      payload: false,
    });
  }
};
